"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkActiveOrder = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../apis/FutureAPI");
const TriggersApi_1 = require("../../apis/TriggersApi");
/**检测是否存在活跃订单 */
function checkActiveOrder(accountType, symbol) {
    const triggerParams = {
        accountType: accountType,
        // 止盈止损单不计算在内
        trigger_function: "NORMAL",
        symbol_type: "PERP",
        limit: 1,
    };
    const orderParams = {
        accountType: accountType,
        symbol_type: "PERP",
        limit: 1,
    };
    if (symbol) {
        triggerParams.symbol = symbol;
        orderParams.symbol = symbol;
    }
    return (0, rxjs_1.zip)((0, TriggersApi_1.queryActiveTriggers)(triggerParams), (0, FutureAPI_1.queryActiveOrders)(orderParams)).pipe((0, operators_1.map)(([triggers, orderData]) => {
        var _a;
        const length = ((triggers === null || triggers === void 0 ? void 0 : triggers.length) || 0) + (((_a = orderData === null || orderData === void 0 ? void 0 : orderData.orders) === null || _a === void 0 ? void 0 : _a.length) || 0);
        return length > 0;
    }));
}
exports.checkActiveOrder = checkActiveOrder;
